module.exports = __webpack_public_path__ + "img/adam_butler.371b3788.png";